import { FileStreamFilter } from "./types";

export const transformUser = (
  filter: FileStreamFilter,
  user: string | null,
): string => {
  if (filter.user === "ALL") return "";
  else {
    return user ? user : "";
  }
};

export const FILE_STREAM_SORT = {
  upload_date: "Upload date",
  file_name: "File name",
  size: "Quota usage",
};
